<template functional>
  <div class="centered-component">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'CenteredComponent'
}
</script>

<style scoped>
  .centered-component {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
</style>
